interface Props {
  wert: number
  von: number
  groesse?: 'md' | 'lg'
  pips?: boolean
}

/** Konviktion = Zahl der Linsen mit Kaufsignal (BUY oder STRONG). */
export default function Conviction({ wert, von, groesse = 'md', pips = false }: Props) {
  const nenner = von > 0 ? von : 7
  return (
    <span
      className={`q-conv${groesse === 'lg' ? ' q-conv--lg' : ''}`}
      aria-label={`Konviktion ${wert} von ${nenner}`}
    >
      <span className="q-conv-num">
        {wert}
        <span className="q-conv-von">/{nenner}</span>
      </span>
      {pips && (
        <span className="q-pips" aria-hidden="true">
          {Array.from({ length: nenner }, (_, i) => (
            <span key={i} className={`q-pip${i < wert ? ' is-on' : ''}`} />
          ))}
        </span>
      )}
    </span>
  )
}
